module.exports = __webpack_public_path__ + "img/header-3.2f138559.png";